import FilterRequest from '../../../../../Spirit/Common/Extensions/Models/FilterRequest';

export default class MeditationsRequest extends FilterRequest {
	CategoryId?: number = null;
	Name?: string = '';
	constructor(obj?: Partial<MeditationsRequest>) {
		super(obj);
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
